import { useCurrentReflection } from '@/hooks'
import { adminclassMentorGraduatesTermAtom, selectedRoleAtom } from '@/store'
import { isNil } from '@seiue/util'
import { useAtomValue } from 'jotai'

import { TimeRange } from '../../../types'
import { SemesterInfo } from '../types'

/**
 * 获取时间范围对应的变量 var: 1 (按本周、上周查)、2 （按上月查）、3（按学期查）
 *
 * @param timeRange
 */
export const getTimeRangeVar = (timeRange: TimeRange) => {
  switch (timeRange) {
    case 'week':
      return 1
    case 'last-week':
      return 1
    case 'month':
      return 2
    case 'semester':
      return 3
    default:
      return 1
  }
}

/**
 * 获取首页数据看板卡片 api 查询参数
 *
 * @param param0 - 参数
 * @param param0.timeRange - 时间范围
 * @param param0.semesterInfo - 学期
 * @returns query
 */
export const getStatsApiQuery = ({
  timeRange,
  semesterInfo,
}: {
  timeRange: TimeRange
  semesterInfo: SemesterInfo
}) => {
  // 按学期查不传 week_number
  const week_number =
    ['last-week', 'week'].includes(timeRange) &&
    !isNil(semesterInfo.week_number)
      ? timeRange === 'last-week'
        ? semesterInfo.week_number === 1
          ? semesterInfo.week_number
          : semesterInfo.week_number - 1
        : semesterInfo.week_number
      : undefined

  return {
    week_number,
    month_number:
      timeRange === 'month' && !isNil(semesterInfo.month_number)
        ? semesterInfo.month_number
        : undefined,
    var: getTimeRangeVar(timeRange),
  }
}

/**
 * 获取首页数据看板卡片 api 查询参数
 *
 * @param param0 - 参数
 * @param param0.timeRange - 时间范围
 * @param param0.semesterInfo - 学期
 * @returns query
 */
export const useStatsApiQuery = ({
  timeRange,
  semesterInfo,
}: {
  timeRange: TimeRange
  semesterInfo: SemesterInfo
}) => {
  const reflection = useCurrentReflection()
  const query = getStatsApiQuery({ timeRange, semesterInfo })
  const advisorRole = useAtomValue(selectedRoleAtom)
  const adminclassGraduateTermName = useAtomValue(
    adminclassMentorGraduatesTermAtom
  )

  return {
    advisor_usin: reflection?.usin || '',
    semester_id: semesterInfo.semester_id,
    advisor_role: advisorRole,
    graduates_in_term_name: adminclassGraduateTermName,
    ...query,
  }
}
